module.exports = __webpack_public_path__ + "static/media/kyu.41cd6bc2.png";